import { memo } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { AppointmentResponseViewModel } from 'types/appointment';
import { AppointmentDetailsConfirmed } from 'components/Appointments/Details/AppointmentDetailsConfirmed';
import { AppointmentDetailsAddress } from 'components/Appointments/Details/AppointmentDetailsAddress';
import getTransformedDate from 'utils/getTransformedDate';
import { AppointmentDetailsRow } from './AppointmentDetailsRow';
import { AppointmentDetailsAttachments } from './AppointmentDetailsAttachments';

interface Props {
    data: AppointmentResponseViewModel;
    onConfirm?: (isConfirmed: boolean) => void;
}

export const AppointmentDetails = memo(({ data, onConfirm }: Props) => {
    return (
        <Box>
            <Stack gap={2} py={4}>
                <AppointmentDetailsRow title="Client" description={`${data.firstName} ${data.lastName}`} />
                <AppointmentDetailsRow title="Description" description={data.description} />
                <AppointmentDetailsRow title="Phone Number" description={data.phoneNumber} />
                <AppointmentDetailsRow title="Email" description={data.email} />
                <AppointmentDetailsAddress address={data.address} placeId={data.placeId} />
                <AppointmentDetailsRow title="House Description" description={data.houseDescription} />
                <AppointmentDetailsRow
                    title="Client Preffered DateTime"
                    description={getTransformedDate(data.scheduledDateTime)}
                />
                <AppointmentDetailsRow
                    title="Scheduled"
                    description={getTransformedDate(data.scheduledDateTime) || 'not confirmed'}
                />
                <AppointmentDetailsRow title="Date Confirmed" description={getTransformedDate(data.dateConfirmed)} />
                <AppointmentDetailsConfirmed isConfirmed={data.isContractorConfirmed} onConfirm={onConfirm} />
                <AppointmentDetailsAttachments title="Attachments" attachments={data.attachments} />
            </Stack>
        </Box>
    );
});
